import { createContext } from 'react';

import { ClientCustomer } from '@funnels/types';

export const INITIAL_CUSTOMER_CONTEXT_DATA: ClientCustomer = {
  data: {
    id: undefined,
    firstName: undefined,
    lastName: undefined,
    mobileNumber: undefined,
    email: undefined,
    brand: undefined,
    isDeleted: undefined,
    updatedAt: undefined,
    createdAt: undefined,
    mobileVerified: undefined,
    emailVerified: undefined,
  },
  isFetching: false,
};

export const CustomerContext = createContext<ClientCustomer>(INITIAL_CUSTOMER_CONTEXT_DATA);
